export class ListIdpGroupsResponse {
    'groups';
    'totalCount';
    'nextToken';
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "groups",
            "baseName": "groups",
            "type": "Array<IdpGroup>",
            "format": ""
        },
        {
            "name": "totalCount",
            "baseName": "totalCount",
            "type": "number",
            "format": ""
        },
        {
            "name": "nextToken",
            "baseName": "nextToken",
            "type": "string",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return ListIdpGroupsResponse.attributeTypeMap;
    }
    constructor() {
    }
}
